<template>
  <div class="container">
    <div class="new-student">
      <b-container fluid class="mx-auto">
        <h1 class="title">{{ title }}</h1>
        <div id="alerts">
          <b-alert
            :show="dismissCountDown"
            dismissible
            variant="success"
            @dismissed="dismissCountDown = 0"
            @dismiss-count-down="countDownChanged"
            >You have successfully added a student!</b-alert
          >
          <b-alert :show="showError" dismissible variant="warning"
            >Something went wrong. Please ensure you entered at least a first
            name, last name and sex.</b-alert
          >
        </div>
        <b-row>
          <b-col>
            <student-basic singular="student" plural="students"></student-basic>
          </b-col>
          <b-col>
            <geo-info
              plural="students"
              singular="student"
              :coords="false"
            ></geo-info>
          </b-col>
        </b-row>
        <!-- <b-card no-body>
          <b-tabs card>
            <b-tab title="Attendance" active>
              <div class="attendance">
                <h4 class="sub-title">Attendance</h4>
                <h6>You must first create a student before editing their attendance records!</h6>
              </div>
            </b-tab>
            <b-tab title="Feeding">
              <div class="school-feeding">
                <h4 class="sub-title">School Feeding</h4>
                <h6>You must first create a student before editing their feeding records!</h6>
              </div>
            </b-tab>
            <b-tab title="Dropped Out">
              <div class="drop-out">
                <h4 class="sub-title">Drop Out</h4>
                <h6>You must first create a student before editing their drop out records!</h6>
              </div>
            </b-tab>
            <b-tab title="School Ready">
              <school-ready status="schoolReady" class="srs"></school-ready>
            </b-tab>
            <b-tab title="Student Tracking">
              <h4 class="sub-title">Student Tracking</h4>
              <h6>You must first create a student before editing their tracking records!</h6>
            </b-tab>
          </b-tabs>
        </b-card>-->
      </b-container>
    </div>
    <br />
    <confirm-submit></confirm-submit>
    <b-button
      :size="'lg'"
      :variant="'primary'"
      class="app_school_btn mb-4"
      :disabled="isDisabled"
      @click.prevent="addStudent"
      >{{ title }}</b-button
    >
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
// import SchoolReady from "@/components/SchoolReady";
import StudentBasic from '@/components/StudentBasic';
import GeoInfo from '@/components/GeoInfo';
import ConfirmSubmit from '@/components/ConfirmSubmit';

export default {
  name: 'NewStudent',
  components: {
    // SchoolReady,
    GeoInfo,
    StudentBasic,
    ConfirmSubmit,
  },
  data() {
    return {
      itemsPerRow: 20,
      addOrEdit: this.$route.path.includes('/add'),
      showError: false,
      selectCurrent: false,
      selectPrevious: false,
      dismissSecs: 3,
      dismissCountDown: 0,
      dismissParentCountDown: 0,
      isDisabled: false,
    };
  },
  computed: {
    ...mapGetters({
      getFirstName: 'students/getFirstName',
      getLastName: 'students/getLastName',
    }),
    title() {
      if (this.$route.path.includes('/add')) {
        return 'Add Student';
      }
      return 'Edit Student';
    },
    formError() {
      if (this.$store.state.students.student.first_name.length <= 1) {
        return false;
      }
      if (this.$store.state.students.student.last_name.length <= 1) {
        return false;
      }
      if (this.$store.state.students.student.sex.length <= 1) {
        return false;
      }
      if (this.$store.state.students.student.country.length <= 1) {
        return false;
      }
      if (this.$store.state.students.student.region.length <= 1) {
        return false;
      }
      if (this.$store.state.students.student.district.length <= 1) {
        return false;
      }
      return true;
    },
  },
  methods: {
    ...mapActions({
      CREATE_STUDENT: 'students/CREATE_STUDENT',
      RESET_STUDENTS_STATE: 'students/RESET_STUDENTS_STATE',
    }),
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    flashSuccess() {
      this.dismissCountDown = this.dismissSecs;
    },
    flashError() {
      this.showError = !this.showError;
    },
    async addStudent() {
      if (!this.$store.state.confirmed) {
        alert('Please confirm the information above is correct');
        return;
      }
      // if (!this.$store.state.students.student.currentTeacher.length) {
      //   alert("You need to select a current teacher to create a new student");
      //   return;
      // }
      if (!this.formError) {
        window.scrollTo(0, 0);
        this.flashError();
        return;
      }
      this.isDisabled = true;
      await this.CREATE_STUDENT();
      window.scrollTo(0, 0);
      await this.flashSuccess();
      await this.RESET_STUDENTS_STATE();
      await this.$store.commit('resetConfirmed');
      this.isDisabled = false;
      // setTimeout(() => this.$router.push({ name: 'StudentsList' }), 1500);
    },
  },
  created() {
    this.RESET_STUDENTS_STATE();
  },
};
</script>

<style scoped>
.container {
  align-content: center;
  width: 100%;
}
.form div {
  margin: 20px;
}
.app_school_btn {
  background: #4d7ef7;
  color: #fff;
  padding: 10px 80px;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: bold;
  width: 520px;
  border: none;
  cursor: pointer;
}
label {
  margin-top: 2%;
  margin-bottom: -0.5%;
}
label.left {
  float: left;
}
div.col {
  margin: 1%;
  padding: 1%;
  border: 1px solid gray;
}
div#assigned-schools {
  float: left;
}
.custom-control-label::before {
  font-size: 10px;
}
#previous-teachers {
  list-style-type: none;
  display: inline;
}

.sub-sub-title {
  float: left;
}
div.col.ignore-outline {
  border: 0px solid white;
}
div.col.box {
  max-height: 250px;
  overflow-y: auto;
}
</style>
